import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `matches`,
      method: 'post',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Match Created Successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'prepend',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `matches/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Updated Sucessfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `matches/${args?.id}`,
      method: 'delete',
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `matches/${args?.id}`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'matches',
      method: 'get',
      data: args?.data,
      params: args?.params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const updateStatus = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `matches/status/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Status Updated Sucessfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const joinedBy = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `matches/joins`,
      method: 'get',
      params: args?.params,
      authorization: true,
      ...(args?.params && { params: args.params }),
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }

    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const userJoinedMatches = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `matches/joins?userId=${args?.id}`,
      method: 'get',
      params: args?.params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }

    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const updateJoinedUserStatus = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `matches/joins`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'updated successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }

    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const updateGameResultAdmin = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `matches/claim-admin-created-match/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Results saved successfully.',
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const updateGameResultPlayer = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `matches/claim-player-created-match/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Results updated successfully',
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
export default {
  find,
  list,
  create,
  update,
  remove,
  updateStatus,
  joinedBy,
  updateJoinedUserStatus,
  updateGameResultAdmin,
  updateGameResultPlayer,
  userJoinedMatches,
}
